import { toIsoLocal } from './iso-date';

// Returns the latest YYYY-MM-DD a direct guest can pick as check-in/checkout.
// Uses the runtime-config value bookingWindowDays (default 180 = 6 months,
// chosen to match the Airbnb Availability window so our site never offers
// dates Airbnb has pulled from sale). The window is computed from "today"
// in the caller's local timezone — pickers and server validation both call
// this so the boundary is consistent on either side.
//
// All math runs through local-Date constructors / setters because the rest
// of the booking flow speaks calendar days in local time (VueDatePicker
// emits local-midnight Dates; toIsoLocal extracts day via local getters).
// Mixing in UTC helpers from iso-date.ts would shift the boundary by a day
// in any timezone west of UTC.
export function getMaxBookableIso(windowDays: number, now: Date = new Date()): string {
  return toIsoLocal(getMaxBookableDate(windowDays, now));
}

// Convenience for VueDatePicker — needs a Date object, not an ISO string.
export function getMaxBookableDate(windowDays: number, now: Date = new Date()): Date {
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const max = new Date(today);
  max.setDate(today.getDate() + Math.max(0, Math.trunc(windowDays)));
  return max;
}

// Pure check used by server endpoints. checkin/checkout are YYYY-MM-DD.
// Returns true when both dates fall within [today, today + windowDays].
export function isWithinBookingWindow(
  checkin: string,
  checkout: string,
  windowDays: number,
  now: Date = new Date(),
): boolean {
  const todayIso = toIsoLocal(new Date(now.getFullYear(), now.getMonth(), now.getDate()));
  const maxIso = getMaxBookableIso(windowDays, now);
  return checkin >= todayIso && checkout <= maxIso;
}
